import { useState } from "react";
import CustomButtonSimple from "../../../../components/CustomMiscellaneous/CustomButtonSimple";
import { PlanoDeAmostragem } from "./PlanoDeAmostragem";
import { NaoConformidade } from "./NaoConformidade";


export function ControloEQualidadeSpecifics({ pecasParaEntrega }: { pecasParaEntrega: any }) {

    const [planoAmostragensOpen, setPlanoAmostragensOpen] = useState(false);
    const [naoConformidadeOpen, setNaoConformidadeOpen] = useState(false);


    return (
        <>
            <div className="flex w-1/2 justify-around items-center">
                <CustomButtonSimple text="Plano de amostragem" onClick={() => setPlanoAmostragensOpen(true)} />
                <CustomButtonSimple
                    className=" text-rodrimaq-red bg-white border-rodrimaq-red font-bold hover:bg-rodrimaq-red hover:text-white" text="Abrir não conformidade"
                    onClick={() => setNaoConformidadeOpen(true)}
                />
            </div>
            {
                planoAmostragensOpen ?
                    <PlanoDeAmostragem
                        planoAmostragensOpen={planoAmostragensOpen}
                        setPlanoAmostragensOpen={setPlanoAmostragensOpen}
                    /> : null
            }

            {
                naoConformidadeOpen ?
                    <NaoConformidade
                        pecasEntrega={pecasParaEntrega}
                        naoConformidadeOpen={naoConformidadeOpen}
                        setNaoConformidadeOpen={setNaoConformidadeOpen}
                    /> : null
            }

        </>
    )


}